import React, { useContext } from "react";
import { createPortal } from "react-dom";
import "./CampaignDetailsPop.scss";
import CampaignDetailsTab from "../../../containers/Campaigns/OverviewTabs/CampaignDetailsTab";
import { IconJsxer } from "../../../helpers/IconHelper";
import { AuthContext } from "../../../contexts/AuthContext";
import { TopBarContext } from "../../../contexts/TopBarContext";
import { ACCOUNT_TYPES } from "../../../helpers/AccountTypes";

const CampaignDetailsPop = (props) => {
    const [authContext] = useContext(AuthContext);
    const [topBarContext] = useContext(TopBarContext);
    const canEdit = authContext && authContext.userData && authContext.userData.userLevel >= ACCOUNT_TYPES.producer.level;

    return (
        <>
            {props.shown && createPortal(
                <div className="settings-pop-canceller" onClick={props.hideFunc}></div>,
                document.body
            )}
            {createPortal(
                <div className={`campaign-details-pop-container${props.shown ? '' : ' hidden'}`} style={props.anchor && props.anchor.left ? { left: props.anchor.left + 'px', top: props.anchor.top + 'px', right: 'auto' } : {}}>
                    <div className="campaign-details-pop-inner" onClick={(e) => e.stopPropagation()}>
                        <div className="cdp-header fl-row">
                            <div className="cdp-spacer" />
                                <div className="cdp-right-actions fl-row">
                                {/* Edit / Save / Discard controls - only for producers */}
                                {canEdit && !props._editMode && (
                                    <div className="cdp-edit" onClick={() => { if (props.onToggleEdit) { props.onToggleEdit(); } }} title="Edit Campaign">{IconJsxer.GetIcon(IconJsxer.ICONS.edit, IconJsxer.ICON_STYLES.settingsEdit)}</div>
                                )}
                                {canEdit && props._editMode && (
                                    <>
                                        <div className="cdp-discard" onClick={() => { if (props.onDiscard) { props.onDiscard(); } }} title="Discard Changes">{IconJsxer.GetIcon(IconJsxer.ICONS.trash, IconJsxer.ICON_STYLES.standard)}</div>
                                        <button className="cdp-save-button" onClick={() => { if (props.onSave) { props.onSave(); } }}>Save Changes</button>
                                    </>
                                )}
                                <div className="cdp-close" onClick={() => { if (props.hideFunc) { props.hideFunc(); } }} title="Close">{IconJsxer.GetIcon(IconJsxer.ICONS.closeX, IconJsxer.ICON_STYLES.standard)}</div>
                            </div>
                        </div>
                        <div className="cdp-content">
                            <CampaignDetailsTab
                                _editMode={props._editMode}
                                _editedCampaignData={props._editedCampaignData}
                                _changeEditedCampaignData={props._changeEditedCampaignData}
                                _campaignTierData={props._campaignTierData}
                                _currentRegion={props._currentRegion}
                                _regionListData={props._regionListData}
                                _setCurrentRegion={props._setCurrentRegion}
                                _addProducers={props._addProducers}
                                _removeProducer={props._removeProducer}
                                _addClientContacts={props._addClientContacts}
                                _removeClientContact={props._removeClientContact}
                                _editCampaignOwner={props._editCampaignOwner}
                                _isPopup={true}
                                _lookupAirTable={props._lookupAirTable}
                                _lookupLoading={props._lookupLoading}
                                _lookupResult={props._lookupResult}
                                _makeTemplate={props._makeTemplate}
                            />
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    )
}

export default CampaignDetailsPop;
